import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Button,
    Tooltip
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import { icons } from '../../common/CommonIcons';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';
import DataGridToolbar from '../../common/DataGridToolbar';
import DataGridTable from '../../common/DataGridTable';
import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';

import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useAppContextFeatures } from '../../../context/AppContext';
import { useDocuments, documentTypes, targetTypes } from '../../../hooks/api/useDocuments';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';

export default function ListItemRelocates({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useDocuments({ documentType: documentTypes.itemRelocate });

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getLocationIds } = useAppContextFeatures();

    const gridRef = React.createRef();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.itemRelocate.id)

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            const result = await list(props)

            return {
                data: result?.data?.documents,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {
        defineColumnsView()
    }, [])

    const defineColumnsView = () => {

        defineColumns([
            {
                name: 'location_name', header: t('location')
            },
            {
                name: 'doc_number',
                header: t('docNo'),
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`documents/itemRelocate/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'doc_date', header: t('date')
            },
            {
                name: 'doc_remark', header: t('remark')
            },
            {
                name: 'items',
                header: t('totalQty'),
                renderValue: ({ value, cellProps }) => {

                    const total = value.reduce((total, item) => total + parseFloat(item.qty), 0)

                    return (
                        <>
                            {total}
                        </>
                        // <Button 
                        //     size='small'
                        //     variant={"outlined"}
                        //     color={`primary`}
                        //     sx={{
                        //         textAlign: "center",
                        //         // width: 100
                        //     }}
                        //     // onClick={() => {
                        //     //     navigate(getRoute(`documents/itemReceive/verifyIn/${cellProps.data?.id}`))
                        //     // }}
                        // >


                        // </Button>
                    )

                }
            },

            {
                name: 'Confirm',
                header: t('status'),
                defaultFlex: 1,
                // showColumnMenuTool: false,
                // rendervalue: ({ value }) => {
                //     return value == 1? "ACTIVE" : "IN-ACTIVE"
                // }
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay((value), [t("confirmed"), t("pending")], ["primary", "default"], "")
            },

        ])
    }

    const handleDelete = async () => {

        try {

            let result = await remove({ ids: selectedIds, targetType: targetTypes.itemRelocate })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

        } catch (error) {
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("documents/itemRelocate/new"));

                    }
                })
            }

            if (isPermissionAllow({ scopeId: scopeIds.operation.id, scopeType: scopeTypes.operation.itemRelocateThreshold.id, functionType: functionTypes.pageView.id })) {
                props.push({
                    displayText: t("relocateThreshold"),
                    // displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("operations/itemThreshold/relocate"));

                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.itemRelocates })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("itemRelocates")}
                breadcrumbs={[
                    {
                        displayText: t("itemRelocates"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }


        </Box>
    )
}
